import { Box, styled } from '@mui/material';
var StyledPublicWrapper = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    minHeight: '100vh',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.whisper
  };
  return styles;
});
var StyledMain = styled(Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'inline';
  }
})(function (_ref2) {
  var theme = _ref2.theme,
      inline = _ref2.inline;
  var styles = {
    flex: '1',
    width: '100%',
    paddingTop: inline ? 0 : theme.spacing(4),
    paddingBottom: inline ? 0 : theme.spacing(4)
  };
  return styles;
});
export { StyledMain, StyledPublicWrapper };